import styled from 'styled-components';

export const ItemsAmountRow = styled.div`
  margin-top: 30px;
`;

export const NoUserFound = styled.div`
  width: 100%;
  text-align: center;
  font-size: 18px;
  color: ${({ theme }) => theme.baseBlue.a6};
`;
